import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CenterConfig } from '@core/models/centerConfig.interface';
import { environment } from '../environments/environment';
import { resolveApiUrl } from '../environments/resolve-api-url';
import { AuthorizedApiService } from '@core';
@Injectable({
    providedIn: 'root',
})
export class CenterService {
    private http = inject(HttpClient);
    private authorizedApi = inject(AuthorizedApiService);
    private readonly api = resolveApiUrl(environment.apiUrl);

    getCenterConfigByDomain(domain: string): Observable<CenterConfig> {
        // console.log('Fetching center config for domain:', domain);
        // const normalizedDomain = domain.trim();
        // const headers = normalizedDomain
        //     ? new HttpHeaders({ 'x-forwarded-host': normalizedDomain })
        //     : undefined;

        return this.http.get<CenterConfig>(`${this.api}/public/centers/center-config`)
    }

    getCenterConfig(center: string): Observable<CenterConfig> {
        return this.authorizedApi.get<CenterConfig>(`centers/${center}`);
    }
}
